import React from 'react';
import { ConfigContext } from '../../providers/ConfigContext';
import { Button } from 'ui-components/src/components/atoms/Button';
import { Container, Subtitle, Title } from './styles';
import { signOut } from 'aws-amplify/auth';

export const NotAuthorizedView = () => {
  const config = ConfigContext.useContainer();

  const handleLogout = async () => {
    try {
      await signOut();
      // Redirect to Cognito logout URI if configured
      window.location.href =
        config.cognito?.redirectSignOut || window.location.origin;
    } catch (error) {
      console.error('Error signing out', error);
    }
  };

  return (
    <Container>
      <Title>You are not authorized to use this application</Title>
      <Subtitle>
        If this is incorrect then please contact your administrator to request
        access
      </Subtitle>
      <Button onClick={handleLogout}>Log out</Button>
    </Container>
  );
};
